import axios from 'axios'
import { QUOTATION_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getQuotations(page, filter, store) {
    const params = {
        page,
        filter,
        store_id: store,
    }
    return axios.get(QUOTATION_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function deleteQuotation(id) {

    const path = `${QUOTATION_URL}/${id}`

    return axios.delete(path, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function getQuotation(id) {

    const url = `${QUOTATION_URL}/${id}`
    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function newQuotation(quotation) {
    const url = `${QUOTATION_URL}?store_id=${quotation.store}`
    return axios.post(url, quotation, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function updateQuotation(id, quotation) {
    const url = `${QUOTATION_URL}/${id}?store_id=${quotation.store}`
    return axios.put(url, quotation, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/quotation.js